// Canonical profile completeness calculation
// Single source of truth — used by Dashboard, ChatWindow, usePortfolioHealth

export const PROFILE_FIELDS = [
  'investment_goals',
  'risk_tolerance',
  'investment_horizon',
  'monthly_investment',
  'holdings'
];

export function calculateProfileCompleteness(profile) {
  if (!profile) return 0;
  const filled = PROFILE_FIELDS.filter(f => {
    const val = profile[f];
    if (Array.isArray(val)) return val.length > 0;
    return val && val !== '';
  }).length;
  return Math.round((filled / PROFILE_FIELDS.length) * 100);
}
